import React, { useState, useMemo } from "react";
import { useThemeMode } from "../../../context/contextTheme";
import "./style.css";

const Solutions = ({ data }) => {
  const { theme } = useThemeMode();
  const [modalContent, setModalContent] = useState("");
  const solutionList = useMemo(() => {
    if (!Array.isArray(data)) return [];
  
    const solutions = [];
  
    data.forEach(vul => {
      if (!vul || !vul.solution) return;  
      if (typeof vul.solution === "object" && !Array.isArray(vul.solution)) {
        if (vul.solution.name) solutions.push(vul.solution.name);  
        if (vul.solution.ref) solutions.push(`Reference: ${vul.solution.ref}`);  
        if (vul.solution.sysMetric) solutions.push(`SysMetric: ${vul.solution.sysMetric}`);
      }  
      else if (typeof vul.solution === "string") {
        if (vul.solution.trim() !== "") solutions.push(vul.solution.trim());
      }
  
      else if (Array.isArray(vul.solution)) {
        vul.solution.forEach(sol => {
          if (sol && typeof sol === "string" && sol.trim() !== "")
            solutions.push(sol.trim());
        });
      }
    });
  
    return [...new Set(solutions)];
  }, [data]);

  const handleReadMore = (content) => {
    setModalContent(content);

    try {
      const modalElement = document.getElementById("staticBackdropSolution");
      if (modalElement && window.bootstrap) {
        const modal = new window.bootstrap.Modal(modalElement);
        modal.show();
      }
    } catch (err) {
      console.error("Modal error:", err);
    }
  };

  const truncateText = (text, wordLimit = 20) => {
    if (!text || typeof text !== "string") return "";
    const words = text.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };

  return (
    <>
      <div className="p-2 pb-0 mb-3">
        <div
          className="card rounded-4 shadow-sm w-100"
          style={{
            minWidth: 300,
            maxWidth: 360,
            height: 200,
            backgroundColor: theme.background,
            border: `1px solid ${theme.border}`,
          }}
        >
          <div className="card-body p-4">
            <h6
              className="card-title fw-semibold mb-2"
              style={{ fontSize: "20px", color: theme.textColor }}
            >
              Solutions
            </h6>

            {/* Solution Carousel */}
            {solutionList.length > 0 ? (
              <div
                id="solutionCarousel"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-inner">
                  {solutionList.map((text, idx) => (
                    <div
                      key={idx}
                      className={`carousel-item ${idx === 0 ? "active" : ""}`}
                    >
                      <p
                        className="small px-3"
                        style={{ lineHeight: 1.6, color: theme.textColor }}
                      >
                        {truncateText(text)}{" "}
                        {text.split(" ").length > 20 && (
                          <button
                            type="button"
                            className="btn underline ms-1 fw-semibold"
                            style={{
                              fontSize: 13,
                              color: theme.textColorInv,
                              background: theme.textColor,
                              padding: "2px 6px",
                            }}
                            onClick={() => handleReadMore(text)}
                          >
                            Read More
                          </button>
                        )}
                      </p>
                    </div>
                  ))}
                </div>

                {/* Prev Button */}
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#solutionCarousel"
                  data-bs-slide="prev"
                  style={{
                    color: theme.textColorInv,
                    backgroundColor: theme.textColor,
                    border: `1px solid ${theme.border}`,
                    borderRadius: 5,
                    width: 30,
                    height: 60,
                    left: -25,
                    top: 14,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span className="carousel-control-prev-icon"></span>
                </button>

                {/* Next Button */}
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#solutionCarousel"
                  data-bs-slide="next"
                  style={{
                    color: theme.textColorInv,
                    backgroundColor: theme.textColor,
                    border: `1px solid ${theme.border}`,
                    borderRadius: 5,
                    width: 30,
                    height: 60,
                    right: -25,
                    top: 14,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span className="carousel-control-next-icon"></span>
                </button>
              </div>
            ) : (
              <p style={{ color: theme.textMuted }}>No solutions found.</p>
            )}
          </div>
        </div>
      </div>

      {/* Modal */}
      <div
        className="modal fade"
        id="staticBackdropSolution"
        tabIndex="-1"
        aria-hidden="true"
        data-bs-keyboard="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
          <div className="modal-content bg-dark text-white rounded-3">
            <div className="modal-header border-secondary">
              <h5 className="modal-title">Full Solution</h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">{modalContent}</div>

            <div className="modal-footer border-secondary">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Solutions;
